// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type StoryDecorator = (storyFn: () => any) => any;
